import { ToastrModule } from 'ngx-toastr'
import { environment } from 'src/environments/environment'

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http'
import { ErrorHandler, NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { StoreRouterConnectingModule } from '@ngrx/router-store'
import { MetaReducer, StoreModule } from '@ngrx/store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import {
  TranslateHttpLoader,
  provideTranslateHttpLoader
} from '@ngx-translate/http-loader'

import { AuthModule } from './auth/auth.module'
import { reducers } from './core.state'
import { AppErrorHandler } from './error-handler.service'
import { ErrorInterceptor } from './interceptors/error.interceptor'
import { LocalStorageService } from './local-storage.service'
import { NotificationService } from './notification.service'
import { localStorageSyncReducer } from './storage.reducer'
import { TranslatorService } from './translator.service'
import { UtilityService } from './utility.service'

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer]

@NgModule({
  declarations: [],
  exports: [TranslateModule],
  imports: [
    BrowserAnimationsModule,
    StoreModule.forRoot(reducers, {
      metaReducers
    }),
    StoreRouterConnectingModule.forRoot(),
    environment.production
      ? []
      : StoreDevtoolsModule.instrument({
          name: 'Angular NgRx'
        }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      }
    }),
    ToastrModule.forRoot(),
    AuthModule
  ],
  providers: [
    LocalStorageService,
    TranslatorService,
    NotificationService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    UtilityService,
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {}
